// The theme's quick buy popup closes when the theme's cart drawer opens after an add. With the
// Rebuy cart that drawer never opens, so the popup is closed here once its item is in the cart.
document.addEventListener('variant:add', (event) => {
  event.target.closest?.('quick-buy-modal')?.hide?.();
});
